import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const GkclLogo = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon height={26} width={21} {...other}>
			<path
				d="M20.6806 23.6377H0.690186V25.8063H20.6806V23.6377ZM20.7867 0.303223H14.1189V6.97037C17.8019 6.97037 20.7867 3.98618 20.7867 0.303223ZM20.7867 20.303C20.7867 16.6223 17.8019 13.6381 14.1189 13.6381V20.303H20.7867ZM7.45168 6.97037H14.1189V13.6381H7.45168V20.303H0.786132V0.303223H7.45168V6.97037Z"
				id="GkclLogo"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

GkclLogo.propTypes = {
	color: PropTypes.string,
};

export default GkclLogo;
